<div #scrollContainer animate.enter="enter-animation"
  class="relative overflow-auto h-[100vh] flex flex-col page-slow-scroll"
>
  <div
    [class]="scrolled ? 'bg-white/80 backdrop-blur-sm' : 'bg-transparent'"
    class="top-0 fixed z-20 w-full transition-all duration-200 ease-in-out"
  >
    <app-guest-top-bar></app-guest-top-bar>
  </div>

  <app-hero-section></app-hero-section>
  <app-product-strip-section></app-product-strip-section>
  <app-features-section></app-features-section>
  <app-ads-showcase-section></app-ads-showcase-section>
  <app-how-it-works-section></app-how-it-works-section>
  <app-testimonials-section></app-testimonials-section>
  <!-- <app-plans-and-pricing></app-plans-and-pricing> -->
  <app-app-store-banner-section></app-app-store-banner-section>
  <app-faq-section></app-faq-section>
  <app-footer-section></app-footer-section>
  <router-outlet></router-outlet>
</div>
